export default "__VITE_PUBLIC_ASSET__ebf324cf__"